import { plural } from '@lingui/core/macro';
import { differenceInYears, format } from 'date-fns';

import isValidDate from './is-valid-date';

type Params = {
  birthDate?: Date;
  getYears?: boolean;
  fallback?: string;
};

/** «21 год», «2 года», «5 лет». Функция, а не константа: язык читается в момент вызова. */
export function formatAge(years: number): string {
  return plural(years, { one: '# год', few: '# года', many: '# лет', other: '# года' });
}

export default function getBirthDay(params: Params) {
  const { birthDate, getYears = true, fallback = '-' } = params;
  if (!(birthDate instanceof Date)) return fallback;
  if (!isValidDate(birthDate)) return fallback;
  const birthDateString = birthDate ? format(birthDate, 'dd.MM.yyyy') : '';
  if (!getYears) return birthDateString;
  const years = birthDate ? differenceInYears(new Date(), birthDate) : null;
  const yearsString = years ? formatAge(years) : '';
  return birthDateString ? `${birthDateString} (${yearsString})` : '-';
}
